import * as standardLevels from '@/assets/data/standardLevels_EN.js';
import * as standardLevelsData from '@/assets/data/standardLevelsData.js';
import firebase from 'firebase/app';
require('firebase/auth');
import db from "@/firebase/init";

export default {
  setStandardLevels(state) {
    // set the level title description etc.. (English)
    state.standardLevelsCompareIntervalSizes = standardLevels.compareIntervalSizes;
    state.standardLevelsIdentifyIntervals = standardLevels.identifyIntervals;
    state.standardLevelsIdentifyChords = standardLevels.identifyChords;
    state.standardLevelsIdentifyChordInversions = standardLevels.identifyChordInversions;
    state.standardLevelsIdentifyScales = standardLevels.identifyScales;
  },
  setStandardLevelsData(state) {
    state.standardLevelsCompareIntervalSizesData = standardLevelsData.compareIntervalSizesData;
    state.standardLevelsIdentifyIntervalsData = standardLevelsData.identifyIntervalsData;
    state.standardLevelsIdentifyChordsData = standardLevelsData.indentifyChordsData;
    state.standardLevelsIdentifyChordInversionsData = standardLevelsData.identifyChordInversionsData;
    state.standardLevelsIdentifyScalesData = standardLevelsData.identifyScalesData;
  },
  setCurrentlySelectedStandardLevelData(state, data) {
    
    state.currentlySelectedStandardLevelData = state[`standardLevels${state.currentRouteName}Data`][data];
  },
  setCurrentlySelectedLevel(state, data) {
    // MIGHT HAVE TO CHANGE THE CHECK, SO ITS NOT CHECKING ROUTE NAME BUT .... SOMETHING GLOBAL
    let disciplineOfSelecetedLevel;
    if (state.currentRouteName === 'IdentifyChords' || state.currentRouteName === 'playIdentifyChordsExercise' || state.currentRouteName === 'playIdentifyChordsUserExercise' || state.currentRouteName === 'createIdentifyChordsExercise' || state.currentRouteName === 'editIdentifyChordsExercise') {
      disciplineOfSelecetedLevel = 'IdentifyChords';
    }
    if (state.currentRouteName === 'IdentifyIntervals' || state.currentRouteName === 'playIdentifyIntervalsExercise' || state.currentRouteName === 'playIdentifyIntervalsUserExercise' || state.currentRouteName === 'createIdentifyIntervalsExercise' || state.currentRouteName === 'editIdentifyIntervalsExercise') {
      disciplineOfSelecetedLevel = 'IdentifyIntervals';
    }
    if (state.currentRouteName === 'CompareIntervalSizes' || state.currentRouteName === 'playCompareIntervalSizesExercise' || state.currentRouteName === 'playCompareIntervalSizesUserExercise' || state.currentRouteName === 'createCompareIntervalSizesExercise' || state.currentRouteName === 'editCompareIntervalSizesExercise') {
      disciplineOfSelecetedLevel = 'CompareIntervalSizes';
    }
    if (state.currentRouteName === 'IdentifyChordInversions' || state.currentRouteName === 'playIdentifyChordInversionsExercise' || state.currentRouteName === 'playIdentifyChordInversionsUserExercise' || state.currentRouteName === 'createIdentifyChordInversionsExercise' || state.currentRouteName === 'editIdentifyChordInversionsExercise') {
      disciplineOfSelecetedLevel = 'IdentifyChordInversions';
    }
    if (state.currentRouteName === 'IdentifyScales' || state.currentRouteName === 'playIdentifyScalesExercise' || state.currentRouteName === 'playIdentifyScalesUserExercise' || state.currentRouteName === 'createIdentifyScalesExercise' || state.currentRouteName === 'editIdentifyScalesExercise') {
      disciplineOfSelecetedLevel = 'IdentifyScales';
    }

    state.currentlySelectedLevel[data.type][disciplineOfSelecetedLevel] = data.level;

    // Set currently Selected standard Level Data
    // state.currentlySelectedLevel['standard'][`${disciplineOfSelecetedLevel}Data`] = state[`standardLevels${disciplineOfSelecetedLevel}Data`][data.index];
  },
  setSoundSequenceNames(state) {
    state.soundSequenceNames = standardLevels.soundSequenceNames;
  },
  initializeSelectedLevels(state) {
    // Preselect selected level for each discipline in the Standard levels (first level in discipline)
    state.currentlySelectedLevel.standard.CompareIntervalSizes = state.standardLevelsCompareIntervalSizes[0];
    state.currentlySelectedLevel.standard.IdentifyIntervals = state.standardLevelsIdentifyIntervals[0];
    state.currentlySelectedLevel.standard.IdentifyChords = state.standardLevelsIdentifyChords[0];
    state.currentlySelectedLevel.standard.IdentifyChordInversions = state.standardLevelsIdentifyChordInversions[0];
    state.currentlySelectedLevel.standard.IdentifyScales = state.standardLevelsIdentifyScales[0];

    // Preselect selected level Data
    state.currentlySelectedLevel.standard.CompareIntervalSizesData = state.standardLevelsCompareIntervalSizesData[0];
    state.currentlySelectedLevel.standard.IdentifyIntervalsData = state.standardLevelsIdentifyIntervalsData[0];
    state.currentlySelectedLevel.standard.IdentifyChordsData = state.standardLevelsIdentifyChordsData[0];
    state.currentlySelectedLevel.standard.IdentifyChordInversionsData = state.standardLevelsIdentifyChordInversionsData[0];
    state.currentlySelectedLevel.standard.IdentifyScalesData = state.standardLevelsIdentifyScalesData[0];


    // Preselect selected Userlevels like above, if there are any
    if (state.userLevelsCompareIntervalSizes.length) {
      state.currentlySelectedLevel.user.CompareIntervalSizes = state.userLevelsCompareIntervalSizes[state.userLevelsCompareIntervalSizes.length - 1];
    }
    if (state.userLevelsIdentifyIntervals.length) {
      state.currentlySelectedLevel.user.IdentifyIntervals = state.userLevelsIdentifyIntervals[state.userLevelsIdentifyIntervals.length - 1];
    }
    if (state.userLevelsIdentifyChords.length) {
      state.currentlySelectedLevel.user.IdentifyChords = state.userLevelsIdentifyChords[state.userLevelsIdentifyChords.length -1 ];
    }
    if (state.userLevelsIdentifyChordInversions.length) {
      state.currentlySelectedLevel.user.IdentifyChordInversions = state.userLevelsIdentifyChordInversions[state.userLevelsIdentifyChordInversions.length - 1];
    }
    if (state.userLevelsIdentifyScales.length) {
      state.currentlySelectedLevel.user.IdentifyScales = state.userLevelsIdentifyScales[state.userLevelsIdentifyScales.length - 1];
    }
    
  },
  setShowLevels(state, levelType) {
    state.showLevels = levelType;
  },
  addUserExercise(state, userExercise) {
    // the first item in the array is the name of the userlevels to add to, the second is the action (copy or save), the third is the exercise data
    
    let disciplineToAddTo = userExercise[0];
    let action = userExercise[1]
    let exerciseToAdd = userExercise[2];
    // Add to store
    state[disciplineToAddTo].unshift(exerciseToAdd);
    // Add to DB
    const uid = firebase.auth().currentUser.uid;
    db.runTransaction(t => {
      const ref = db.collection('users').doc(uid);
      return t.get(ref).then(doc => {
        const arrayData = doc.data()[disciplineToAddTo];
        // Mutate array data
        arrayData.unshift(exerciseToAdd);
        // re-add array to db
        t.update(ref, {[disciplineToAddTo]: arrayData});
      });
    }).then(() => {
      // Show snackbar
      let snackbarText;
      if (action === 'copy') {
        snackbarText = 'Exercise copied!';
      } else if (action === 'create') {
        snackbarText = 'Exercise added!';
      }
      state.snackbar = {
        showing: true,
        timeout: 3000,
        text: snackbarText
      };
    }).catch((err => {
      console.log('Transaction failed:', err);
    }))
  },
  replaceUserExercise(state, userExercise) {
    const disciplineToReplaceInto = userExercise[0];
    const editedExercise = userExercise[1];

    // Get array of user exercises in this discipline
    const exerciseArray = state[disciplineToReplaceInto];
    
    // Find index that matches id of exercise being edited
    const indexToReplace = exerciseArray.findIndex(
      (exercise) => exercise.id.toString() === editedExercise.id.toString()
    );
    
    // Add edited exercise to Firestore.
    const uid = firebase.auth().currentUser.uid;
    db.runTransaction(t => {
      const ref = db.collection('users').doc(uid);
      return t.get(ref).then(doc => {
        const arrayData = doc.data()[disciplineToReplaceInto];
        // Mutate array
        arrayData[indexToReplace] = editedExercise;
        // re-add array to db
        t.update(ref, {[disciplineToReplaceInto]: arrayData})
      });
    }).then(() => {
      state.snackbar = {
        showing: true,
        timeout: 3000,
        text: 'Exercise was updated'
      };
    }).catch((err) => {
      console.log(err.message);
    }); 

    state[disciplineToReplaceInto][indexToReplace] = editedExercise;
  },
  deleteExercise(state, exerciseInfo) {
    // Delete in Store
    state[exerciseInfo.exerciseListToDeleteFrom].splice(exerciseInfo.exerciseToDeleteID, 1);
    // Delete in DB
    let uid = firebase.auth().currentUser.uid;
    db.runTransaction(t => {
      const ref = db.collection('users').doc(uid);
      return t.get(ref).then(doc => {
        let arrayData = doc.data()[exerciseInfo.exerciseListToDeleteFrom];
        // Mutate array data
        arrayData = state[exerciseInfo.exerciseListToDeleteFrom];
        // re-add array to db
        t.update(ref, {[exerciseInfo.exerciseListToDeleteFrom]: arrayData});
      });
    }).then(() => {
      state.snackbar = {
        timeout: 3000,
        showing: true,
        text: 'Exercise deleted'
      };
    }).catch((err => {
      state.snackbar = {
        timeout: 3000,
        text: 'Could not delete exercise. Try again later.',
        color: 'error'
      };
      console.log('Transaction failed:', err);
    }))

  },
  setCurrentRouteName(state, routeName) {
    state.currentRouteName = routeName;
  },
  setCurrentRoutePath(state, routePath) {
    state.currentRoutePath = routePath;
  },
  setCurrentUserDiscipline(state, userDiscipline) {
    state.currentUserDiscipline = userDiscipline;
  },
  setIsExerciseBeingEdited(state, payload) {
    state.isExerciseBeingEdited = payload;
  },
  setExerciseBeingEdited(state, exerciseBeingEdited) {
    state.exerciseBeingEdited = exerciseBeingEdited;
  },
  setCorrectNotes(state, correctNotes) {
    state.correctNotes = correctNotes;
  },
  setIncorrectNotes(state, incorrectNotes) {
    state.incorrectNotes = incorrectNotes;
  },
  setCorrectNotesPositionX(state, correctNotesPositionX) {
    state.dotsPositionCorrect = correctNotesPositionX;
  },
  setIncorrectNotesPositionX(state, incorrectNotesPositionX) {
    state.dotsPositionIncorrect = incorrectNotesPositionX;
  },
  addAnswerToprogressLamps(state, answer) {
    state.progressLamps.push(answer);
  },
  resetprogressLamps(state) {
    state.progressLamps = [];
  },
  setIsGameRunning(state, isGameRunning) {
    state.isGameRunning = isGameRunning;
  },
  setExercisePlaying(state, exercisePlaying) {
    state.exercisePlaying = exercisePlaying;
  },
  setDisciplinePlaying(state, discipline) {
    state.disciplinePlaying = discipline;
  },
  setCurrentExerciseIndex(state, currentExerciseIndex) {
    state.currentExerciseIndex = currentExerciseIndex;
  },
  setcurrentExerciseRandomQuestions(state, payload) {
    state.currentExerciseRandomQuestions = payload;
  },
  setquestionNumberInCurrentExercise(state, payload) {
    state.questionNumberInCurrentExercise = payload;
  },
  setCorrectAnswer(state, correctAnswer) {
    state.correctAnswer = correctAnswer;
  },
  setUserAnswer(state, userAnswer) {
    state.userAnswer = userAnswer;
  },
  setSoundsequenceDataForCorrectAnswer(state, soundSequenceData) {
    state.soundSequenceDataForCorrectAnswer = soundSequenceData;
  },
  setQuestionStartNote(state, questionStartNote) {
    state.questionStartNote = questionStartNote;
  },
  setDisciplineModeTonal(state, disciplineMode) {
    state.disciplineModeTonal = disciplineMode;
  },
  setWaitingForUserAnswer(state, payload) {
    state.waitingForUserAnswer = payload;
  },
  setShowEvaluationPopup(state, showEvaluationPopup) {
    state.showEvaluationPopup = showEvaluationPopup
  },
  setCurrentExerciseScore(state, exerciseScore) {
    state.currentExerciseScore = exerciseScore;
  },
  resetCurrentExerciseScore(state, payload) {
    state.currentExerciseScore = payload;
  },
  resetProgressLamps(state, payload) {
    state.progressLamps = payload;
  },
  setCorrectAnswersInCurrentExercise(state, correctAnswers) {
    state.correctAnswersInCurrentExercise = correctAnswers;
  },
  setNextQuestionText(state, payload) {
    state.nextQuestionText = payload;
  },
  setCorrectOrWrongAnswer(state, payload) {
    state.correctOrWrongAnswer = payload;
  },
  setCompareIntervalSizesCorrectData(state, payload) {
    state.compareIntervalSizesCorrectData = payload;
  },
  setCompareIntervalSizesIncorrectData(state, payload) {
    state.compareIntervalSizesIncorrectData = payload;
  },
  setAnswersForPossibleIdentifyChordInversions(state, payload) {
    state.answersForPossibleIdentifyChordInversions = payload;
  },
  setAllAnswerPossibilitiesForChordInversions(state, payload) {
    state.allAnswerPossibilitiesForChordInversions = payload;
  },
  setStartnoteBeforeInvert(state, payload) {
    state.startnoteBeforeInvert = payload;
  },
  setSoundSequenceForIntervalAandIntervalB(state, payload) {
    state.soundSequenceForIntervalAandIntervalB = payload;
  },
  setAllStandardExerciseScores(state, payload) {
    state.standardExerciseScores = payload;
  },
  setAllUserExercises(state, payload) {
    state.userLevelsCompareIntervalSizes = payload['userLevelsCompareIntervalSizes'];
    state.userLevelsIdentifyIntervals = payload['userLevelsIdentifyIntervals'];
    state.userLevelsIdentifyChords = payload['userLevelsIdentifyChords'];
    state.userLevelsIdentifyChordInversions = payload['userLevelsIdentifyChordInversions'];
    state.userLevelsIdentifyScales = payload['userLevelsIdentifyScales'];

  },
  setStandardScore(state, payload) {
    // NOTE REFACTOR TO MAKE MORE LIKE setUserScore method
    let currentDiscipline = state.disciplinePlaying;
    let i = payload.index;
    let score = payload.score; 
    if (state.user) {
      let uid = firebase.auth().currentUser.uid;
      switch(currentDiscipline) {
        case 'standardLevelsIdentifyChords':
          // Set score in store
          state.standardExerciseScores.identifyChordsScores[i] = score;
          db.collection('users').doc(uid).update({
            "standardExerciseScores.identifyChordsScores": state.standardExerciseScores.identifyChordsScores
          })
          .then(() => {
            
          }).catch((err) => {
            console.log(err.message);
          });

          break;
        case 'standardLevelsIdentifyIntervals':
          state.standardExerciseScores.identifyIntervalsScores[i] = score;
          db.collection('users').doc(uid).update({
            "standardExerciseScores.identifyIntervalsScores": state.standardExerciseScores.identifyIntervalsScores
          })
          .then(() => {
            
          }).catch((err) => {
            console.log(err.message);
          });
          break;
        case 'standardLevelsCompareIntervalSizes':
          state.standardExerciseScores.compareIntervalSizesScores[i] = score;
          db.collection('users').doc(uid).update({
            "standardExerciseScores.compareIntervalSizesScores": state.standardExerciseScores.compareIntervalSizesScores
          })
          .then(() => {
           
          }).catch((err) => {
            console.log(err.message);
          });
          break;
        case 'standardLevelsIdentifyChordInversions':
          state.standardExerciseScores.identifyChordInversionsScores[i] = score;
          db.collection('users').doc(uid).update({
            "standardExerciseScores.identifyChordInversionsScores": state.standardExerciseScores.identifyChordInversionsScores
          })
          .then(() => {
           
          }).catch((err) => {
            console.log(err.message);
          });
          break;
        case 'standardLevelsIdentifyScales':
          state.standardExerciseScores.identifyScalesScores[i] = score;
          db.collection('users').doc(uid).update({
            "standardExerciseScores.identifyScalesScores": state.standardExerciseScores.identifyScalesScores
          })
          .then(() => {
           
          }).catch((err) => {
            console.log(err.message);
          });
          break;
      }
    } else {
      
      return;
    }
   
  },
  setUserScore(state, payload) {

    let userDisciplineToAddScoreTo = payload.userDiscipline;
    let i = payload.index;
    let score = payload.score;
    state[userDisciplineToAddScoreTo][i].score = score;
    // Update array in database
    const uid = firebase.auth().currentUser.uid;
    db.runTransaction(t => {
      const ref = db.collection('users').doc(uid);
      return t.get(ref).then(doc => {
        const arrayData = doc.data()[userDisciplineToAddScoreTo];
        // Mutate array data
        arrayData[i] = state[userDisciplineToAddScoreTo][i];
        // re-add array to db
        t.update(ref, {[userDisciplineToAddScoreTo]: arrayData});
      });
    }).then(() => {
      
    }).catch((err => {
      console.log('Transaction failed:', err.message);
    }))



  },
  setTimeIntervalBetweenNotes(state, payload) {
    state.gameSettings.timeInterval = payload;
  },
  setAutoContinue(state, payload) {
    state.gameSettings.autoContinue = payload;
  },
  setVolume(state, payload) {
    state.gameSettings.volume = payload;
  },
  setPlayScaleOctave(state, payload) {
    state.gameSettings.playScaleOctave = payload;
  },
  setPlayableKeyboard(state, payload) {
    state.gameSettings.playableKeyboard = payload;
  },
  setAnswerSound(state, payload) {
    state.gameSettings.answerSound = payload;
  },
  setShowExerciseDescription(state, payload) {
    state.showExerciseDescription = payload;
  },
  setShowExerciseList(state, payload) {
    state.showExerciseList = payload;
  },
  setShowCreateExerciseSoundSequenceList(state, payload) {
    state.showCreateExerciseSoundSequenceList = payload;
  },
  setShowCreateExerciseSettings(state, payload) {
    state.showCreateExerciseSettings = payload;
  },
  setShowUserExerciseDescription(state, payload) {
    state.showUserExerciseDescription = payload;
  },
  setShowUserExerciseList(state, payload) {
    state.showUserExerciseList = payload;
  },
  // User stuff
  setUser(state, payload) {
    state.user = payload;
  },
  setAccessToken(state, payload) {
    state.accessToken = payload;
  },
  setShowSignUpDialog(state, payload) {
    state.showSignUpDialog = payload;
  },
  setShowLogInDialog(state, payload) {
    state.showLogInDialog = payload;
  },
  setShowUserMenu(state, payload) {
    state.showUserMenu = payload;
  },
  setShowUserMenuDialogMobile(state, payload) {
    state.showUserMenuDialogMobile = payload;
  },
  setShowLoginSignupBottomSheet(state, payload) {
    state.showLoginSignupBottomSheet = payload;
  },
  setShowLoginToAccessDialog(state, payload) {
    state.showLoginToAccessDialog = payload;
  },
  setUserObject(state, payload) {
    state.userObject = payload;
  },
  setShowDataCopiedToDatabaseDialog(state, payload) {
    state.showDataCopiedToDatabaseDialog = payload;
  },
  setSnackbar(state, snackbar) {
    state.snackbar = snackbar;
  },
  setAlertDialog(state, alertDialog) {
    state.alertDialog = alertDialog;
  },
  resetUserScores(state, payload) {
    const {userLevelsCompareIntervalSizes, userLevelsIdentifyIntervals, userLevelsIdentifyChords, userLevelsIdentifyChordInversions, userLevelsIdentifyScales} = payload;
    state.userLevelsCompareIntervalSizes = userLevelsCompareIntervalSizes;
    state.userLevelsIdentifyIntervals = userLevelsIdentifyIntervals;
    state.userLevelsIdentifyChords = userLevelsIdentifyChords;
    state.userLevelsIdentifyChordInversions = userLevelsIdentifyChordInversions;
    state.userLevelsIdentifyScales = userLevelsIdentifyScales;
  },
  resetStandardScores(state, payload) {
    state.standardExerciseScores = payload;
  },
  deleteUserExercises(state) {
    state.userLevelsCompareIntervalSizes = [],
    state.userLevelsIdentifyIntervals = [],
    state.userLevelsIdentifyChords = [],
    state.userLevelsIdentifyChordInversions = [],
    state.userLevelsIdentifyScales = []
  },
  setNavigatedFromStartButton(state, payload) {
    state.navigatedFromStartButton = payload;
  }
}